import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _disconnectAccountRequest = {};
var _disconnectAccountResponse = {};
var _disconnectConfigurationRequest = {};
var _disconnectConfigurationResponse = {};
var _getConfigurationRequest = {};
var _getConfigurationResponse = {};
var _listConfigurationsRequest = {};
var _listConfigurationsResponse = {};
function resolveComWixpressRestaurantsPostpaapiRestaurantsPosTpaApiUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/restaurants/v1/pos-spi-host',
                destPath: '/v1/pos-spi-host',
            },
        ],
        'com.wixpress.restaurants.restaurants-pos-spi-host.wixapps.net': [
            {
                srcPath: '/restaurants-pos-spi-host',
                destPath: '/v1/pos-spi-host',
            },
        ],
        'www.wixapps.com': [
            {
                srcPath: '/restaurants/v1/pos-integration',
                destPath: '/v1/pos-integration',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/restaurants/v1/pos-integration',
                destPath: '/v1/pos-integration',
            },
        ],
        'users._base_domain': [
            {
                srcPath: '/_api/restaurants/v1/pos-spi-host',
                destPath: '/v1/pos-spi-host',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** This endpoint gets a location configuration by ID on the Wix site. */
export function getConfiguration(payload) {
    var _a = serializer(_getConfigurationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getConfigurationResponse, {}).fromJSON;
    function __getConfiguration(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.postpaapi.v1.configuration',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.postpaapi.RestaurantsPosTpaApi.GetConfiguration',
            url: resolveComWixpressRestaurantsPostpaapiRestaurantsPosTpaApiUrl({
                protoPath: '/v1/pos-integration/configurations/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getConfiguration.fromReq = fromReq;
    __getConfiguration.__isAmbassador = true;
    return __getConfiguration;
}
/** This endpoint retrieves a list of location configurations on the Wix site. */
export function listConfigurations(payload) {
    var _a = serializer(_listConfigurationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listConfigurationsResponse, {}).fromJSON;
    function __listConfigurations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.postpaapi.v1.configuration',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.postpaapi.RestaurantsPosTpaApi.ListConfigurations',
            url: resolveComWixpressRestaurantsPostpaapiRestaurantsPosTpaApiUrl({
                protoPath: '/v1/pos-integration/configurations',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listConfigurations.fromReq = fromReq;
    __listConfigurations.__isAmbassador = true;
    return __listConfigurations;
}
/**
 * This endpoint disconnects the account between the merchant and the POS service provider.
 *
 * The account is not deleted. You can reconnect to the account using the POS integration settings in the Dashboard.
 *
 * Call the [List Account IDs](https://dev.wix.com/api/rest/wix-restaurants/point-of-sale-integration/pos-connectivity-spi/list-account-ids) SPI endpoint to retrieve a list of existing account IDs.
 */
export function disconnectAccount(payload) {
    var _a = serializer(_disconnectAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_disconnectAccountResponse, {}).fromJSON;
    function __disconnectAccount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.postpaapi.v1.configuration',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.postpaapi.RestaurantsPosTpaApi.DisconnectAccount',
            url: resolveComWixpressRestaurantsPostpaapiRestaurantsPosTpaApiUrl({
                protoPath: '/v1/pos-integration/accounts/{accountId}/disconnect',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __disconnectAccount.fromReq = fromReq;
    __disconnectAccount.__isAmbassador = true;
    return __disconnectAccount;
}
/**
 * This endpoint disconnects the Wix location configuration from a POS service provider's location.
 *
 * The configuration is not deleted. You can reconnect to the configuration using the POS integration settings in the Dashboard.
 *
 * Call the [List Configurations](https://dev.wix.com/api/rest/wix-restaurants/point-of-sale-integration/pos-connectivity-api/list-configurations) SPI endpoint to retrieve a list of existing configuration IDs.
 */
export function disconnectConfiguration(payload) {
    var _a = serializer(_disconnectConfigurationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_disconnectConfigurationResponse, {}).fromJSON;
    function __disconnectConfiguration(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.postpaapi.v1.configuration',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.postpaapi.RestaurantsPosTpaApi.DisconnectConfiguration',
            url: resolveComWixpressRestaurantsPostpaapiRestaurantsPosTpaApiUrl({
                protoPath: '/v1/pos-integration/configurations/{configurationId}/disconnect',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __disconnectConfiguration.fromReq = fromReq;
    __disconnectConfiguration.__isAmbassador = true;
    return __disconnectConfiguration;
}
//# sourceMappingURL=http.impl.js.map